import _ from "lodash";

const GROUP_CATEGORY = {
  GENERAL: "General",
  WEBRECOMMENDED: "Web Recommended Prebid",
  MOBILERECOMMENDED: "Mobile Recommended Prebid",
  SUMMARY: "Summary",
};

const baseGroupings = [
  {
    groupName: GROUP_CATEGORY.GENERAL,
    keys: ["network_id", "network_currency", "cache_latest_updated_time"],
  },
  {
    groupName: GROUP_CATEGORY.WEBRECOMMENDED,
    keys: [
      "web_recommended_prebid_setting.send_all_bids_enabled",
      "web_recommended_prebid_setting.prebid_integration_types",
      "web_recommended_prebid_setting.upa_config",
      "web_recommended_prebid_setting.upa_currency",
    ],
  },
  {
    groupName: GROUP_CATEGORY.MOBILERECOMMENDED,
    keys: [
      "mobile_recommened_prebid_setting.send_all_bids_enabled",
      "mobile_recommened_prebid_setting.prebid_integration_types",
      "mobile_recommened_prebid_setting.upa_config",
      "mobile_recommened_prebid_setting.upa_currency",
    ],
  },
  {
    groupName: GROUP_CATEGORY.SUMMARY,
    keys: ["summaries"],
  },
];

export function getPrebidSummarySchema(defaultConfig = {}) {
  const schemas = _getSchemas();
  _.forEach(schemas, (s) => {
    if (s.prefix === "") {
      s.defaultValue = _.get(defaultConfig, [s.key], "-");
    } else {
      s.defaultValue = _.get(defaultConfig, [s.prefix, s.key], "-");
    }
  });
  return _.reduce(
    baseGroupings,
    (result, group) => {
      let { groupName, keys } = group;
      _.forEach(schemas, (keyConfig) => {
        if (_.indexOf(keys, keyConfig.key) !== -1) {
          keyConfig.groupCategory = groupName;
          result.push(keyConfig);
        }
      });
      return result;
    },
    []
  );
}

function _getSchemas() {
  return [
    {
      key: "network_id",
      description: "",
      valueType: "number",
      prefix: "",
    },
    {
      key: "network_currency",
      description: "",
      valueType: "string",
      prefix: "",
    },
    {
      key: "cache_latest_updated_time",
      description: "",
      valueType: "string",
      prefix: "",
    },
    {
      key: "web_recommended_prebid_setting.send_all_bids_enabled",
      description: "",
      valueType: "boolean",
      prefix: "",
      title: "Send All Bids Enabled",
    },
    {
      key: "web_recommended_prebid_setting.prebid_integration_types",
      description: "",
      valueType: "array_changed",
      prefix: "",
      title: "Prebid Integration Types",
    },
    {
      key: "web_recommended_prebid_setting.upa_config",
      description: "",
      valueType: "array_changed",
      prefix: "",
      title: "Upa Config",
    },
    {
      key: "web_recommended_prebid_setting.upa_currency",
      description: "",
      valueType: "string",
      prefix: "",
      title: "Upa Currency",
    },
    {
      key: "mobile_recommened_prebid_setting.send_all_bids_enabled",
      description: "",
      valueType: "boolean",
      prefix: "",
      title: "Send All Bids Enabled",
    },
    {
      key: "mobile_recommened_prebid_setting.prebid_integration_types",
      description: "",
      valueType: "array_changed",
      prefix: "",
      title: "Prebid Integration Types",
    },
    {
      key: "mobile_recommened_prebid_setting.upa_config",
      description: "",
      valueType: "array_changed",
      prefix: "",
      title: "Upa Config",
    },
    {
      key: "mobile_recommened_prebid_setting.upa_currency",
      description: "",
      valueType: "string",
      prefix: "",
      title: "Upa Currency",
    },
    {
      key: "summaries",
      description: "",
      valueType: "array_changed",
      prefix: "",
    },
  ];
}
